// extracted by mini-css-extract-plugin
module.exports = {"panel":"Tabs_panel__26oJX","tab":"Tabs_tab__pBbrK","buttons":"Tabs_buttons__nFVLo","shadow":"Tabs_shadow__b1FIl","button":"Tabs_button__2_ceT","active":"Tabs_active__1xX0X"};